module.exports = __webpack_public_path__ + "img/pdf-white.becd1d33.svg";